// American Football physical constants.
//
// Kept alongside the drawer + sport-specific normalisation helpers so every
// football-specific number lives in one place. Nothing else in libs/pitch
// should hardcode these.
import { unitsMap } from '@frontend/core/lib/domains/units/constants'

// `unitsMap.distance.yards.conversion` is metres→yards (yardsVal =
// metresVal * conversion), so the metres-per-yard factor is its inverse.
// Sourcing from `unitsMap` keeps one canonical conversion across the
// codebase — no bespoke 0.9144 literals.
/** 1 yard expressed in metres. */
export const YARD_M = 1 / unitsMap.distance.yards.conversion

/** NFL hashes sit 23.5 yards from each sideline. */
export const HASH_INSET_YD = 23.5

/** NFL hash inset expressed in metres. */
export const HASH_INSET_M = HASH_INSET_YD * YARD_M

/** Visual length of each hash tick, in yards. */
export const HASH_LEN_YD = 2

/** Pitch width in yards (sideline-to-sideline). */
export const PITCH_WIDTH_YD = 53

/** Pitch width in metres. */
export const PITCH_WIDTH_M = PITCH_WIDTH_YD * YARD_M
